module.exports = __webpack_public_path__ + "img/上对齐3.55773226.svg";